import React from "react";
import { useMutation } from "@apollo/client";
import { RemoveModal } from "components/modal/remove";
import { removeTemplateGroup, removeTemplateGroupVariables } from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import logger from "services/logger";
import { REMOVE_TEMPLATE } from "./remove";

type RemoveTemplateModalProps = {
  templateId: string;
  onSuccess?: () => void;
  controls?: {
    showModal: boolean;
    setShowModal: (showModal: boolean) => void;
  };
};

const DELETE_TEMPLATE_CONFIRM = "Are you sure you want to delete this template?";
const DELETE_ERROR = "Unable to delete this template. Please try again or contact support@havenconnect.com.";

export const RemoveTemplateModal: React.FC<RemoveTemplateModalProps> = ({
  templateId,
  onSuccess,
  controls,
}) => {
  const { openSnackbar } = useSnackbar();
  const [removeTemplate] = useMutation<removeTemplateGroup, removeTemplateGroupVariables>(
    REMOVE_TEMPLATE,
  );

  const handleRemove = async () => {
    try {
      await removeTemplate({
        variables: { id: templateId },
        refetchQueries: ["templateGroups"],
      });
      openSnackbar({ message: "Template deleted successfully", status: "success" });
      onSuccess?.();
    } catch (error: unknown) {
      logger.sendError(error instanceof Error ? error : new Error(String(error)));
      throw error;
    }
  };

  return (
    <RemoveModal
      action={handleRemove}
      buttonText="Delete"
      removalText={DELETE_TEMPLATE_CONFIRM}
      errorText={DELETE_ERROR}
      buttonColor="dangerous"
      controls={controls}
    />
  );
};

